import MapViewPageContainer from './container/MapViewPageContainer'

export default MapViewPageContainer
